import { Directive, ElementRef, inject } from '@angular/core';

/**
 * Directive for projecting a remove button into a chip. Based on Angular Material MatChipRemove pattern.
 *
 * @example
 *   ```html
 *   <harmony-chip label="Removable">
 *     <svg hxChipRemove><use xlink:href="#close-icon" /></svg>
 *   </harmony-chip>
 *   ```;
 */
@Directive({
  selector: '[hxChipRemove]',
  standalone: true,
  host: {
    class: 'hx-chip-remove',
    '[attr.role]': '"img"',
    '[attr.aria-hidden]': '"true"',
  },
})
export class HxChipRemove {
  protected readonly _elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
}
